
export interface IAppointmentTypeConfig{
  appointmentTypeConfig:string;
  name:string;
  code:string;
  isActive:boolean
}
